import { Terms } from "./models/Terms";
import React, { useState, useEffect } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../header/Navbar";
import Modal from "react-bootstrap/Modal";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../../../hooks/useWeb3";
import moment from "moment";
//price
import EthPrice from "../../../hooks/chinaFunction/ethPrice";
import LinkPrice from "../../../hooks/chinaFunction/linkPrice";
import WbtcPrice from "../../../hooks/chinaFunction/wbtcPrice";
//allowance
import AllowanceTpl from "../../../hooks/dataFetchers/AllowanceTpl";
import AllowanceDop from "../../../hooks/dataFetchers/AllowanceDop";
import AllowanceTomi from "../../../hooks/dataFetchers/AllowanceTomi";
import AllowanceGems from "../../../hooks/dataFetchers/AllowanceGems";
import AllowanceWbtc from "../../../hooks/dataFetchers/AllowanceWbtc";
import AllowanceLink from "../../../hooks/dataFetchers/AllowanceLink";
import AllowancePepe from "../../../hooks/dataFetchers/AllowancePepe";
import AllowanceUniswape from "../../../hooks/dataFetchers/AllowanceUniswape";
import AllowanceUsdc from "../../../hooks/dataFetchers/AllowanceUsdc";

//approval
import ApproveTpl from "../../../hooks/dataFetchers/ApproveTpl";
import ApproveTplUsdc from "../../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplWbtc from "../../../hooks/dataFetchers/ApproveTplWbtc";
import ApproveDop from "../../../hooks/dataFetchers/ApproveDop";
import ApproveTomi from "../../../hooks/dataFetchers/ApproveTomi";
import ApproveGems from "../../../hooks/dataFetchers/ApproveGems";
import ApproveLink from "../../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../../hooks/dataFetchers/ApprovePepe";
import ApproveUnisawape from "../../../hooks/dataFetchers/ApproveUniswape";

//balance
import BalacefAccount from "../../../hooks/dataFetchers/BalaceOfAccount";
import BalacefAccountTomi from "../../../hooks/dataFetchers/BlanaceOfAccountTom";
import BalacefAccountGems from "../../../hooks/dataFetchers/BlanaceOfAccountGems";
import BalacefAccountLink from "../../../hooks/dataFetchers/BalacefAccountLink";
import BalacefAccountPepe from "../../../hooks/dataFetchers/BalacefAccountPepe";
import BalacefAccountUni from "../../../hooks/dataFetchers/BalacefAccountUni";
import BalacefAccountUsdc from "../../../hooks/dataFetchers/BalanceOfAccountUsdc";
import BalacefAccountWbtc from "../../../hooks/dataFetchers/BalanceOfAccountWbtc";
import BalacefAccountDop from "../../../hooks/dataFetchers/balanceOfAccountDop";
import BalacefAccountWeth from "../../../hooks/dataFetchers/BalanceOfAccountWeth";

//purchase
import PurchaseEth from "../../../hooks/chinaFunction/purchaseEth";
import PurchaseUsdt from "../../../hooks/chinaFunction/purchaseUsdt";
import PurchaseUsdc from "../../../hooks/chinaFunction/purchaseUsdc";
import PurchaseDop from "../../../hooks/chinaFunction/purchaseDop";
import PurchaseWbtc from "../../../hooks/chinaFunction/purchaseWbtc";
import PurchaseGems from "../../../hooks/chinaFunction/purchaseGems";
import PurchasePepe from "../../../hooks/chinaFunction/purchasePepe";
import PurchaseLink from "../../../hooks/chinaFunction/purchaseLink";
import PurchaseUniswape from "../../../hooks/chinaFunction/purchaseUniswape";
import PurchaseTomi from "../../../hooks/chinaFunction/purchaseTomi";

//
import Loader from "../../../hooks/loader";
import axios from "axios";
import { API_URL, PRICE_API_URL } from "../../../utils/ApiUrl";
import { toast } from "react-toastify";
import CuurentRound from "../../../hooks/chinaFunction/round";
import SaleStatus from "../../../hooks/chinaFunction/saleStatus";
import Timer from "../../../hooks/chinaFunction/timer";
import TimerNft from "../../../hooks/chinaFunction/timeNft";
import { useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DopNft from "../../DopNft/DopNft";
import DiscountedPrice from "../../../hooks/chinaFunction/discountedPrice";
import Environment from "../../../utils/Environment";
import { setupNetwork } from "../../../utils/wallet";
import GetGemsStaked from "../../../hooks/chinaFunction/getGemsStakeAmount";
import { storeReferrer } from "@sharemint/sdk";
import useRecordEvent from "../../../hooks/useRecordEvent";
import RoundTimer from "./RoundTimer";
import useWeb3ErrorToast, {
  generateToast,
} from "../../../utils/useWeb3ErrorToast";
import Footer from "../Footer/Footer";
import useAuth from "../../../hooks/useAuth";
import {
  clearWalletSession,
  setWalletSession,
} from "../../../utils/walletSession";
import { requestWithState } from "../../../@api/requestWithState";
import { notifyInfo } from "../../Toast";
import useApproveToken from "../../../hooks/dataFetchers/useApproveToken";
import usePurchaseToken from "../../../hooks/chinaFunction/usePurchaseToken";
import { getTokenConfig } from "../../../utils/tokenConfig";
import AllowanceWeth from "../../../hooks/dataFetchers/AllowanceWeth";

const CHAIN = process.env.REACT_APP_CHAIN_ID;

const Banner = ({ setShow, projectId }) => {
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  const Presale = Environment?.presale;
  const history = useHistory();
  const web3 = useWeb3();
  const { account, chainId } = useWeb3React();
  const { login, logout } = useAuth();
  const { recordEvent } = useRecordEvent();
  const { handleError } = useWeb3ErrorToast();

  // Inside your component:
  const { approveToken } = useApproveToken();
  const { purchaseToken } = usePurchaseToken();
  //allowance
  const { allowanceTpl } = AllowanceTpl();
  const { allowanceUsdc } = AllowanceUsdc();
  const { allowanceGems } = AllowanceGems();
  const { allowanceDop } = AllowanceDop();
  const { allowanceLink } = AllowanceLink();
  const { allowanceTomi } = AllowanceTomi();
  const { allowancePepe } = AllowancePepe();
  const { allowanceUniswape } = AllowanceUniswape();
  const { allowanceWbtc } = AllowanceWbtc();
  const { allowanceWeth } = AllowanceWeth();
  // //approve
  // const { approveDop } = ApproveDop();
  // const { approveTpl } = ApproveTpl();
  // const { approveTplUsdc } = ApproveTplUsdc();
  // const { approveTplwbtc } = ApproveTplWbtc();
  // const { approveTomi } = ApproveTomi();
  // const { approveGems } = ApproveGems();
  // const { approveLink } = ApproveLink();
  // const { approvePepe } = ApprovePepe();
  // const { approveUnisawape } = ApproveUnisawape();

  // //purchase
  // const { purchaseTomi } = PurchaseTomi();
  // const { purchaseGems } = PurchaseGems();
  // const { purchaseUsdt } = PurchaseUsdt();
  // const { purchaseUsdc } = PurchaseUsdc();
  // const { purchaseWbtc } = PurchaseWbtc();
  // const { purchasePepe } = PurchasePepe();
  // const { purchaseLink } = PurchaseLink();
  // const { purchaseUniswape } = PurchaseUniswape();
  // const { purchaseEth } = PurchaseEth();
  // const { purchaseDop } = PurchaseDop();

  //balance & price
  const { balacefAccountDop } = BalacefAccountDop();
  const { balacefAccount } = BalacefAccount();
  const { balacefAccountTomi } = BalacefAccountTomi();
  const { balacefAccountGems } = BalacefAccountGems();
  const { balacefAccountLink } = BalacefAccountLink();
  const { balacefAccountUni } = BalacefAccountUni();
  const { balacefAccountPepe } = BalacefAccountPepe();
  const { balacefAccountUsdc } = BalacefAccountUsdc();
  const { balacefAccountWbtc } = BalacefAccountWbtc();
  const { balacefAccountWeth } = BalacefAccountWeth();

  const { ethPrice } = EthPrice();
  const { linkPrice } = LinkPrice();
  const { wbtcPrice } = WbtcPrice();

  const { getGemsStaked } = GetGemsStaked();
  //
  const { discountedPrice } = DiscountedPrice();
  const { cuurentRound } = CuurentRound();
  const { saleStatus } = SaleStatus();
  const { timer } = Timer();
  const { timerNft } = TimerNft();

  const [selectedToken, setSelectedToken] = useState("WETH");
  const [tab, setTab] = useState("home");
  const [tagImge, setTagImge] = useState(
    "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
  );
  const [tokenCache, setTokenCache] = useState({});

  const [checkBoxx, setCheckBoxx] = useState(false);
  const [insurancePer, setInsurancePer] = useState(0);

  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  var now11 = new Date();
  let createdDate = now11?.getTime();

  useEffect(() => {
    storeReferrer();
    return () => {};
  }, []);

  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const code = localStorage?.getItem("accessCode");
  const instiPrice = localStorage?.getItem("price_ins");
  const role = localStorage?.getItem("role_ins");
  const startTime11 = localStorage?.getItem("timeeee");
  const [id, setId] = useState(null);
  const [price, setPrice] = useState(null);
  const [round, setRound] = useState(null);
  const [loaderr, setLoarder] = useState(false);
  const [loaderr1, setLoarder1] = useState(false);

  const [currentRoundd, setCurrentRoundd] = useState(null);
  const [copyOfPrice, setCopyOfPrice] = useState(null);
  const [priceCheck, setPriceCheck] = useState(false);
  const [inputFeild, setInputField] = useState(null);
  const [inputFeild1, setInputField1] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  // const [currentTimer, setCurrentTimer] = useState(null);
  const [timeshow, setTimeshow] = useState(false);

  const [saleCurrentStaus, setSaleCurrentStaus] = useState(false);
  const [amountInUsdt, setAmountInUsdt] = useState(null);
  // const [niceName, setNicName] = useState(null);
  const [percent, setPercet] = useState(0);
  const [stakeIndex, setStakeIndux] = useState([]);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [multiplyPercentNumbere, setMultiplyPercentNumbere] = useState(0);
  const [discountedPriceee, setDiscountedPriceee] = useState(0);
  const [ethValueCalcualte, setethValueCalcualte] = useState(null);
  const [stakeEndTime1, setStakeEndTime1] = useState([]);
  const [stakingData1, setStakingData1] = useState({});
  const [allowedTokens, setAllowedTokens] = useState([]);

  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isNewMailRequired, setIsNewMailRequired] = useState(false);
  const [email, setEmail] = useState(null);
  const [isValidMail, setIsValidMail] = useState(true);
  const [isMailVerificationChecked, setIsMailVerificationChecked] =
    useState(false);
  const [otpRequired, setOtpRequired] = useState(false);

  const [otp, setOtp] = useState("");
  const [isCodeValid, setIsCodeValid] = useState(true);
  const [codeSentOnce, setCodeSentOnce] = useState(false);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  const [readDisclaimer, setReadDisclaimer] = useState(false);
  const [checkDisclaimer, setCheckDisclaimer] = useState(false);
  const [checkCitizenship, setCheckCitizenship] = useState(false);
  const [checkMerketing, setCheckMerketing] = useState(true);

  const [showtermsservices, setShowTermsServices] = useState(false);
  const [attemptedDisclaimer, setAttemptedDisclaimer] = useState(false);

  const handleCloseTermsServices = () => {
    setShowTermsServices(false);
  };

  const handleShowTermsServices = () => {
    setReadDisclaimer(true);
    setShowTermsServices(true);
  };

  const handleDisclaimerCheckbox = () => {
    if (!readDisclaimer) {
      setAttemptedDisclaimer(true);
      return;
    }
    setCheckDisclaimer(true);
  };

  const canBuy = checkDisclaimer && checkCitizenship;

  const [modalDelay, setModalDelay] = useState(true);

  setTimeout(() => {
    setModalDelay(false);
  }, 2000);

  const [isVerificationDone, setIsVerificationDone] = useState(true);

  const handleCloseVerification = () => setIsVerificationDone(true);
  const handleShowVerification = () => setIsVerificationDone(false);

  useEffect(() => {
    if (modalDelay) return;
    const data = localStorage.getItem("verifiedData");
    const verifiedData = data ? JSON.parse(data) : null;

    const isVerified =
      !!account &&
      verifiedData?.address.toLowerCase() === account.toLowerCase() &&
      verifiedData?.email;

    if (!account) {
      handleShowVerification();
      return;
    }

    if (isVerified) {
      handleCloseVerification();
      setEmail(verifiedData.email);
      return;
    }

    handleShowVerification();
    checkGeneralVerification();
  }, [account, modalDelay]);

  const checkGeneralVerification = async () => {
    if (!account) return;
    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          by: account.toLowerCase(),
        },
      });
      setLoarder1(false);
      console.log(response?.deta, "Verification Response");
      const data = response?.deta;
      if (data?.isVerified) {
        setIsEmailVerified(true);
        console.log("Verified fetched successfully:", response?.data);
        setEmail(data?.email || null);
        await callRecordEventAgreement(data?.email, true, true);
      } else {
        setIsEmailVerified(false);
        setEmail(data?.email || null);
        setIsNewMailRequired(true);
        // await callRecordEventAgreement(data?.email);
        console.log("User is not verified");
      }
    } catch (error) {
      setIsEmailVerified(false);
      setEmail(null);
      console.error("Error checking verified:", error);
    } finally {
      setLoarder1(false);
    }
  };

  const handlCheckEmailVerification = async () => {
    if (!isValidEmail(email)) {
      setIsValidMail(false);
      return;
    }

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/email-details?email=${email}&by=${account.toLowerCase()}`,
        method: "GET",
      });

      const data = response?.deta;
      console.log(response, "Email Verification Check Response");
      if (data?.isFullyVerified) {
        await callRecordEventAgreement(email, true, true);
        handleContinueWithVerifiedMail();
      } else {
        setOtpRequired(true);
      }
    } catch (error) {
      console.error("Error checking verified:", error);
    } finally {
      setLoarder1(false);
      setIsMailVerificationChecked(true);
    }
  };

  const handleSendCode = async () => {
    if (!isValidEmail(email)) {
      setIsValidMail(false);
      return;
    }

    const url = isNewMailRequired
      ? `/emails/verify-email`
      : `/emails/update-email`;

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url,
        method: isNewMailRequired ? "POST" : "PATCH",
        data: {
          by: account.toLowerCase(),
          email: email.trim(),
        },
      });

      console.log(response?.deta, "Send Code Response");

      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        handleContinueWithVerifiedMail();
        await callRecordEventAgreement(email, true, true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        setCodeSentOnce(true);
        toast.success("Verification code sent to your email", {
          className: "verification-toast",
          position: "top-right",
        });

        // Start cooldown
        setIsResendDisabled(true);
        setResendTimer(10);
      }
    } catch (error) {
      console.error("Error updating email:", error);
    } finally {
      setLoarder1(false);
    }
  };

  const handlVerifyCode = async () => {
    console.log("Verifying code:", otp, email);
    if (otp?.trim()?.length === 0 || otp?.trim()?.length !== 6) {
      setIsCodeValid(false);
      return;
    }

    try {
      setLoarder1(true);
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email: email.trim(),
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        await callRecordEventAgreement(email, true, true);
        setIsEmailVerified(true);
        console.log("Email verified successfully");
        setIsCodeValid(true);
        handleContinueWithVerifiedMail();
      } else {
        setIsCodeValid(false);
      }
    } catch (error) {
      console.error("Error verifying code:", error);
      setIsCodeValid(false);
    } finally {
      setLoarder1(false);
    }
  };

  const [resendTimer, setResendTimer] = useState();
  useEffect(() => {
    let countdown;
    if (resendTimer > 0) {
      countdown = setTimeout(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [resendTimer, isResendDisabled]);

  const handleContinueWithVerifiedMail = () => {
    handleCloseVerification();
    setEmail(email);
    setOtp("");
    setIsEmailVerified(false);
    setIsNewMailRequired(false);
    setIsValidMail(true);
    setIsMailVerificationChecked(false);
    setOtpRequired(false);
    setIsCodeValid(true);
    setCodeSentOnce(false);
    setIsResendDisabled(false);

    localStorage.setItem(
      "verifiedData",
      JSON.stringify({ address: account, email }),
    );
  };

  const handleContinueWithAnotherEmail = () => {
    setIsEmailVerified(false);
    setEmail(null);
  };

  const callRecordEventAgreement = async (
    email,
    emailVerified = false,
    onlyEmailEvent = false,
  ) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode) return;

    const metaData = {
      ...(!onlyEmailEvent && {
        privateSaleAgreement: [
          {
            email,
            agreedToToS: checkDisclaimer,
            agreedToNotUsIsrealCitizen: checkCitizenship,
            agreedToReceiveMarketingEmail: checkMerketing,
            agreedOn: Date.now(),
          },
        ],
      }),
      ...(emailVerified && {
        emailWasVerified: true,
      }),
    };

    await recordEvent(metaData);
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleInputMail = (e) => {
    let value = e.target.value;
    setEmail(value);
    setIsEmailVerified(null);
    setIsValidMail(true);
    setIsMailVerificationChecked(false);
    setOtpRequired(false);
    setCodeSentOnce(false);
    setIsCodeValid(true);
    setOtp("");
  };

  const fetchAllowedTokens = async () => {
    try {
      const response = await axios.get(
        `${API_URL}pro-projects/${projectId}/tokens`,
      );

      const allowedTokenData = response?.data?.data?.[0] || [];
      console.log("allowed tokens", allowedTokenData);
      setAllowedTokens(allowedTokenData.allowedTokensData);
    } catch (error) {
      console.log("fetch allowed tokens error::", error);
    }
  };

  useEffect(() => {
    if (!account) return;

    firstTimeData();
    saleStatusss();
    fetchAllowedTokens();

    setStakeEndTime1([]);
    fetchStakingData();
    fetchStakingData1();
    getGemsStakedAmount();

    setSelectedToken("WETH");
    setTagImge("https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png");
    fetchTokenData("WETH");
    fetchTokenData("ETH");
  }, [account]);

  useEffect(() => {
    if (account) return;

    setTokenCache({});
    setSelectedToken("WETH");
    setTagImge("https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png");
    resetInputs();

    setLoarder1(false);
  }, [account]);

  const saleStatusss = async () => {
    try {
      let b = await saleStatus();
      if (b) {
        console.log(b, "noooor imad");
        setSaleCurrentStaus(b);
      }
    } catch (err) {
      console.log(err.message, "noooor imad");
    }
  };

  const firstTimeData = async () => {
    setLoarder1(true);
    try {
      let b;
      b = await cuurentRound();
      setRound(b);
      let price = 0;
      if (b) {
        if (b == 1) {
          price = 0.2;
        } else {
          price = 0.07;
        }
        console.log("goin into roundData waleed", b, price);
        roundData(b, price);
      }
    } catch (err) {
      console.log(err.message, "nooor");
      setLoarder1(false);
    }
  };

  const buildHeaders = () => ({
    "X-API-Key": Environment.PRICE_KEY,
    "Content-Type": "application/json",
  });

  const uniPriceHandler = async () => {
    try {
      const priceSymbol = "UNI";
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      console.log("get uni price error::", error);
      return null;
    }
  };

  const dopPriceHandler = async () => {
    try {
      const priceSymbol = "DOP2";
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      console.log("get dop price error::", error);
      return null;
    }
  };

  const getPepePrice = async () => {
    try {
      const priceSymbol = "PEPE";
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      console.log("get pepe price error::", error);
      return null;
    }
  };

  const getTomiPrice = async () => {
    try {
      const priceSymbol = "TOMI";
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      console.log("get tomi price error::", error);
      return null;
    }
  };

  const getGemsPrice = async () => {
    try {
      const priceSymbol = "GEMS";
      const res = await fetch(
        `${PRICE_API_URL}/api/v1/markets/${encodeURIComponent(priceSymbol)}/price`,
        { headers: buildHeaders() },
      );

      const data = await res.json();
      return data?.price ?? 0;
    } catch (error) {
      console.log("get gems price error::", error);
      return null;
    }
  };

  const [show1, setShow1] = useState(false);
  const [buyingNetworkFee, setbuyingNetworkFee] = useState(0);

  async function getGasFeeInUSD(txHash) {
    const receipt = await web3.eth.getTransactionReceipt(txHash);
    const tx = await web3.eth.getTransaction(txHash);

    if (!receipt || !tx) {
      throw new Error("Transaction not found");
    }

    const BN = web3.utils.BN;

    const gasUsed = new BN(receipt.gasUsed);
    const gasPrice = new BN(tx.gasPrice); // effective gas price

    const feeInWei = gasUsed.mul(gasPrice);

    const feeInEth = web3.utils.fromWei(feeInWei, "ether");

    // Convert ETH → USD
    const feeInUsd = Number(feeInEth) * tokenCache["ETH"]?.price;
    setbuyingNetworkFee(feeInUsd);
    // return {
    //   gasUsed: receipt.gasUsed,
    //   gasPriceGwei: web3.utils.fromWei(tx.gasPrice, "gwei"),
    //   feeInEth: Number(feeInEth),
    //   feeInUsd
    // };
  }

  const handleClose = () => {
    history.push("/claim/" + Presale?.symbol + "?buy=true");
    setInputField("");
    setInputField1("");
    setbuyingNetworkFee(0);
    setShow1(false);
  };
  const handleShow = () => setShow1(true);

  const resetInputs = () => {
    setInputField1("");
    setInputField("");
  };

  const changeTag1 = async (token) => {
    const selectedToken = tokenConfig[token] || tokenConfig.GEMS;

    discoundedPriceee(currentRoundd, selectedToken.address);
    setSelectedToken(token);
    setTagImge(selectedToken.image);
    resetInputs();
    await fetchTokenData(token);
  };

  const inputField1Handler = (e) => {
    let raw = e.target.value;

    if (raw === "") {
      setInputField("");
      setInputField1("");
      setethValueCalcualte(0);
      setAmountInUsdt(0);
      return;
    }

    // Allow typing like "0." or "."
    if (!/^\d*\.?\d*$/.test(raw)) return;

    setInputField(raw);

    const value = parseFloat(raw);
    if (isNaN(value)) return;

    const tokenData = tokenCache[selectedToken];

    let amount = 0;
    let usdValue = 0;

    if (selectedToken === "USDT" || selectedToken === "USDC") {
      amount = value / price;
      usdValue = value;
    } else {
      amount = (tokenData.price * value) / price;
      usdValue = tokenData.price * value;
    }

    // High-precision normalize
    const preciseAmount = Number(amount.toPrecision(14));

    // Discount difference calc
    const discountedUnits = usdValue / discountedPriceee;
    const diff = discountedUnits - preciseAmount;

    setInputField(value);
    setInputField1(preciseAmount.toFixed(6));
    setAmountInUsdt(usdValue);

    setethValueCalcualte(parseFloat(discountedUnits.toPrecision(12)));

    console.log({
      value,
      amount,
      preciseAmount,
      usdValue,
      discountedUnits,
      diff,
    });
  };

  const callRecordEventTrxTrigger = async (metaData) => {
    await recordEvent(metaData);
  };

  const callRecordEventTrxStatus = async (metaData) => {
    await recordEvent(metaData);
  };

  const handlerPop = async () => {
    if (!navigator.onLine) {
      generateToast("RPC_FAIL");
      return;
    }

    await callRecordEventAgreement(email, true);

    const totalAmount = checkBoxx
      ? parseFloat(inputFeild) + parseFloat(inputFeild) * insurancePer
      : parseFloat(inputFeild);

    const tokenData = tokenCache[selectedToken];
    let userBalance = tokenData ? tokenData.balance : 0;

    if (userBalance < totalAmount) {
      notifyInfo(
        "Insufficient funds. You need additional funds to cover the price and network fees.",
      );
      return;
    }

    if (inputFeild && inputFeild1) {
      if (chainId !== parseInt(CHAIN)) {
        await setupNetwork(CHAIN);
      }
      console.log("confirming called", {
        inputFeild,
        inputFeild1,
        chainId,
        selectedToken,
      });
      confirm();
    }
  };

  const callRecordEventWalletConnect = async (status) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode || !account) return;

    const metaData = {
      connectWallet: [
        {
          walletAddress: account.toLowerCase(),
          status,
          connectedAt: Date.now(),
        },
      ],
    };

    await recordEvent(metaData);

    localStorage.setItem(
      "walletEvent",
      JSON.stringify({
        logged: true,
        presale: Presale.apiTag,
        account: account.toLowerCase(),
      }),
    );
  };

  const connectMetaMask1 = async () => {
    if (account) {
      try {
        const connectorId = window.localStorage.getItem("connectorId");
        await callRecordEventWalletConnect("disconnected");
        await logout(connectorId);
        clearWalletSession();
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");
        localStorage.removeItem("hasReloadedAfterConnect");
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("injected");
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        setWalletSession();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    }
  };

  const trustWallet = async () => {
    if (account) {
      try {
        await callRecordEventWalletConnect("disconnected");
        await logout("walletconnect");
        clearWalletSession();
        localStorage.clear();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("walletconnect");
        setWalletSession();
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
        handleError(err);
      }
    }
  };

  const confirm = async () => {
    setLoarder(true);
    let postApiRes = "";
    let metaData = {};
    let selectedTokenFromAllowed = allowedTokens.find(
      (t) => t.tokenSymbol === selectedToken,
    );

    if (!saleCurrentStaus) {
      toast.error("Sale is Currently Paused");
      setLoarder(false);
      return;
    }

    try {
      // Step 1: Call API
      confirmBuyBefore();

      const config = {
        method: "post",
        url: `${API_URL}pro-projects/buy`,
        data: {
          accessCode: code,
          walletAddress: account.toString(),
          tokenSelected: selectedTokenFromAllowed?._id,
          project: projectId,
          type: "TOKEN",
        },
      };

      postApiRes = await axios(config)
        .then((response) => response?.data?.data)
        .catch((error) => {
          // toast.error(error?.response?.data.message);
          throw error;
        });

      if (!postApiRes) {
        setLoarder(false);
        return;
      }

      // Step 2: Get token configuration
      const tokenConfig = getTokenConfig(selectedToken);
      const tokenData = tokenCache[selectedToken];
      const balanceOfEth = tokenCache["ETH"].balance ?? 0;

      // Step 3: Handle approval (if needed)
      if (tokenConfig.needsApproval) {
        const currentAllowance = tokenData.allowance;

        // Special case for USDT: reset to 0 if insufficient
        if (
          tokenConfig.requiresResetApproval &&
          currentAllowance > 0 &&
          parseFloat(inputFeild) >= currentAllowance
        ) {
          console.log("Resetting USDT approval to 0...");
          await approveToken(tokenConfig.address, 0);
          console.log(`Approving ${selectedToken}...`);
          await approveToken(tokenConfig.address, inputFeild);
          fetchTokenData(selectedToken);
        } else if (
          currentAllowance === 0 ||
          parseFloat(inputFeild) > currentAllowance
        ) {
          console.log(`Approving ${selectedToken}...`);
          await approveToken(tokenConfig.address, inputFeild);
          fetchTokenData(selectedToken);
        }
      }

      // Step 4: Purchase tokens
      const purchaseResult = await purchaseToken({
        mode: selectedToken === "ETH" ? "eth" : "token",
        tokenAddress: tokenConfig.address,
        amount: inputFeild,
        postApiRes: postApiRes,
        currentRound: currentRoundd,
        minAmount: parseFloat(inputFeild1),
        stakeIndex: stakeIndex,
        hasInsurance: checkBoxx,
        insurancePer: insurancePer,
      });

      if (purchaseResult) {
        // Step 5: Post-purchase actions
        if (checkBoxx) {
          confirmBuy12(purchaseResult, postApiRes);
        } else {
          confirmBuy(purchaseResult, postApiRes);
        }

        await getGasFeeInUSD(purchaseResult?.transactionHash);

        // Step 6: Record success
        metaData = {
          transactionStatus: [
            {
              executed: true,
              blockchainSuccess: true,
              ex: "none",
              transactionHash: purchaseResult?.transactionHash,
            },
          ],
        };

        await callRecordEventTrxStatus(metaData);
        fetchTokenData(selectedToken);

        setLoarder(false);
        handleShow();
      }
    } catch (err) {
      console.error("Transaction error:", err);

      // Record failure
      metaData = {
        transactionStatus: [
          {
            executed: false,
            blockchainSuccess: false,
            ex: err.message,
            transactionHash: "none",
          },
        ],
      };

      await callRecordEventTrxStatus(metaData);

      // Refresh token data if not ETH
      if (selectedToken !== "ETH") {
        fetchTokenData(selectedToken);
        fetchTokenData("ETH");
      } else {
        fetchTokenData("ETH");
      }

      setLoarder(false);
      handleError(err);
    }
  };

  // const userLogin1 = async (e) => {

  //   let b = tab === "home" ? "sale-rounds/users" : "sale-rounds/users-nft";
  //   await axios
  //     .get(API_URL + b)
  //     .then(async (res) => {
  //       let a = res.data.data;
  //       a.map((i) => {
  //         if (e == i?.round && i.privateSale == Presale?.apiTag) {
  //           setNicName(i.round);
  //         }
  //       });

  //       setTimeout(() => {
  //         setLoarder1(false);
  //       }, "1000");
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");
  //       setLoarder1(false);
  //     });
  // };

  useEffect(() => {
    if (!code) {
      history.push("/" + Presale?.symbol);
    }
  }, [code]);

  const roundData = async (e, pppp) => {
    try {
      if (parseInt(e) <= 1) {
        // Handle single round case
        const roundInfo = tab === "home" ? await timer(e) : await timerNft(e);

        if (roundInfo) {
          updateRoundState(roundInfo, e);
        }
      } else {
        // Start from current round and go backwards to find active round
        let activeRound = null;
        let roundNumber = null;

        // Check rounds from current (e) down to 1
        for (let i = parseInt(e); i >= 1; i--) {
          const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);

          // Check if this round is currently active
          if (
            currentTime > parseInt(roundInfo.startTime) &&
            currentTime < parseInt(roundInfo.endTime)
          ) {
            activeRound = roundInfo;
            roundNumber = i;
            break; // Found active round, stop searching
          }

          // Store first round for fallback
          if (!activeRound) {
            activeRound = roundInfo;
            roundNumber = i;
          }
        }

        // If no active round found, find the closest one
        if (
          !activeRound ||
          currentTime < parseInt(activeRound.startTime) ||
          currentTime > parseInt(activeRound.endTime)
        ) {
          const allRounds = await fetchAllRounds(e);
          activeRound = findClosestRound(allRounds);
          roundNumber = activeRound.roundNumber;
        }

        updateRoundState(activeRound, roundNumber);
      }
    } catch (err) {
      console.log(err, "error in roundData");
      setLoarder1(false);
    }
  };

  // Helper function to fetch all rounds if needed
  const fetchAllRounds = async (maxRound) => {
    const rounds = [];
    for (let i = 1; i <= maxRound; i++) {
      const roundInfo = tab === "home" ? await timer(i) : await timerNft(i);
      rounds.push({ ...roundInfo, roundNumber: i });
    }
    return rounds;
  };

  // Helper function to find closest round
  const findClosestRound = (rounds) => {
    let closestRound = null;
    let minDiff = Infinity;

    rounds.forEach((round) => {
      const diff = Math.abs(currentTime - parseInt(round.startTime));
      if (diff < minDiff) {
        minDiff = diff;
        closestRound = round;
      }
    });

    return closestRound;
  };

  // Helper function to update state
  const updateRoundState = (roundInfo, roundNumber) => {
    setCurrentRount(roundInfo);
    setCurrentRoundd(roundNumber);
    localStorage.setItem("currentRunningRound", roundNumber);

    const basePrice = roundInfo.price / 10 ** 18;
    const discount = roundNumber == 1 ? 0.2 : 0.07;
    const discountedPrice = basePrice * (1 - discount);

    setPrice(basePrice);
    setCopyOfPrice(basePrice);
    setMultiplyPercentNumbere(discount);
    setDiscountedPriceee(discountedPrice);

    discoundedPriceee(roundNumber, Environment?.eth);
    // if (role !== "institution") {
    //   userLogin1(roundNumber);
    // } else {
    //   setPrice(instiPrice);
    // }

    setTimeout(() => setLoarder1(false), 1000);
  };

  const confirmBuy12 = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, selectedToken, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: selectedToken,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        recipient: account,
        isInsured: true,
        buyingAmountUsd: amountInUsdt?.toFixed(4),
        insuranceFee: parseFloat(inputFeild * insurancePer)?.toFixed(4),
        insuranceFeeUsd: parseFloat(amountInUsdt * insurancePer)?.toFixed(4),
        totalBuyingAmount: parseFloat(
          parseFloat(inputFeild) + parseFloat(inputFeild * insurancePer),
        )?.toFixed(4),
        totalBuyingAmountUsd: parseFloat(
          parseFloat(amountInUsdt) + parseFloat(amountInUsdt * insurancePer),
        )?.toFixed(4),
      },
    };

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, selectedToken, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: selectedToken === "WETH" ? "ETH" : selectedToken,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, selectedToken, 'noooooor');
    let nereValue = ethValueCalcualte?.toPrecision(6);
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: selectedToken === "WETH" ? "ETH" : selectedToken,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: Presale?.apiTag,
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };

    const metaData = {
      purchaseTxn: [
        {
          type: "TOKEN",
          nft: "none",
          amountInvested: parseFloat(inputFeild),
          tokenSelected: selectedToken,
          tokensReceived:
            (stakedAmount >= 5555 && stakingData?.length) ||
            moment().isBefore(stakeEndTime1)
              ? nereValue
              : inputFeild1,
          dollarAmount: parseFloat(amountInUsdt)?.toFixed(4),
        },
      ],
    };

    await callRecordEventTrxTrigger(metaData);

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };

  const tabHandler = (e) => {
    discoundedPriceee(currentRoundd, Environment.eth);
    setSelectedToken("WETH");
    setTagImge("https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png");
    if (tab == "home") {
      setTab("profile");
    } else {
      setTab("home");
    }
  };
  // console.log(price,'buy price');
  const discoundedPriceee = async (aa, e) => {
    // console.log(a,e,'a,e');
    try {
      let ab = await discountedPrice(aa, e);
      // console.log('buy',ab,copyOfPrice);
      if (role != "institution") {
        if (ab > 0) {
          // console.log('if chala');
          setPrice(ab);
          let b = ab;
          let c = b * multiplyPercentNumbere;
          let v = b - c;
          setDiscountedPriceee(v);
          setPercet(100 * ((copyOfPrice - ab) / copyOfPrice));
          console.log(ab, e, "callll ho raHA ");
          setPriceCheck(true);
        } else {
          if (copyOfPrice) {
            setPriceCheck(false);
            setPrice(copyOfPrice);
            let b = copyOfPrice;
            let c = b * multiplyPercentNumbere;
            let v = b - c;
            setDiscountedPriceee(v);
          }
        }
      } else {
        setPrice(instiPrice);
      }
    } catch (err) {
      console.log(err, "discoundedPrice err");
    }
  };

  const fetchStakingData = async () => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {isClaimed: false, staker: "${account}"}) {
          stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.gemsLockingGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        console.log(response, "response");

        const resData = response?.data?.data?.stakeds;
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          // console.log(a, 'mainn1');
          let bcc = a?.sort();
          setStakeIndux(bcc);
          setStakingData(resData);
          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(
            resData[resData?.length - 1]?.stakeEndTime,
          );
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
          if (!endTimeStamp.isValid()) {
            setStakeEndTime(currentTime);
          } else {
            setStakeEndTime(endTimeStamp);
          }
          // setLoarder1(false)
        }
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  const fetchStakingData1 = async (useV2 = false) => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
  subscribeds(where: {by: "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
      blockTimestamp
      blockNumber
      amountPurchased
      by
      endTime
      id
      tokenPrice
      transactionHash
    }
  }`,
      variables: {},
    });

    var config = {
      method: "post",
      url: useV2
        ? Environment.gemSubscriptionMultiple
        : Environment.gemsSubscribeGrap,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then(async function (response) {
        const resData = response?.data?.data?.subscribeds;
        // console.log("43353453454", resData);
        if ((!resData || resData.length === 0) && !useV2) {
          return fetchStakingData1(true);
        }
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          let bcc = a?.sort();
          // setStakeIndux(bcc);
          setStakingData1(resData[0]);

          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds

          if (!endTimeStamp.isValid() || currentTime.isAfter(endTimeStamp)) {
            if (!useV2) {
              // Try again with gemSubscriptionMultiple
              return fetchStakingData1(true);
            } else {
              setStakeEndTime1(currentTime);
            }
          } else {
            setStakeEndTime1(endTimeStamp);
          }
          // setLoarder1(false)
        }
        // setLoarder1(false);
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked) {
      setStakedAmount(staked);
    }
  };

  const fetchTokenData = async (token) => {
    if (!account) return;

    // // ✅ cache hit → no refetch
    // if (tokenCache[token]) return;

    const config = TOKEN_REGISTRY[token];
    if (!config) return;

    setLoarder1(true);

    try {
      const data = {};

      if (config.getBalance) {
        data.balance = await config.getBalance({
          account,
          web3,
          balacefAccount,
          balacefAccountWeth,
          balacefAccountUsdc,
          balacefAccountGems,
          balacefAccountUni,
          balacefAccountLink,
          balacefAccountDop,
          balacefAccountPepe,
          balacefAccountTomi,
          balacefAccountWbtc,
        });
      }

      if (config.hasAllowance && config.getAllowance) {
        data.allowance = await config.getAllowance({
          allowanceTpl,
          allowanceWeth,
          allowanceUsdc,
          allowanceGems,
          allowanceUniswape,
          allowanceLink,
          allowanceDop,
          allowancePepe,
          allowanceTomi,
          allowanceWbtc,
        });
      }

      if (config.getPrice) {
        data.price = await config.getPrice({
          ethPrice,
          getGemsPrice,
          uniPriceHandler,
          linkPrice,
          dopPriceHandler,
          getPepePrice,
          getTomiPrice,
          wbtcPrice,
        });
      }
      console.log("price for", token, "is", data.price);
      setTokenCache((prev) => ({
        ...prev,
        [token]: data,
      }));
    } catch (err) {
      console.error("Token fetch error:", token, err);
    } finally {
      setLoarder1(false);
    }
  };

  // const tokenImages = {
  //   ETH: "/assets/eth-icon.svg",
  //   USDT: "/assets/usdt.svg",
  //   DOP: "/assets/dop.svg",
  //   GEMS: "/assets/newgemslogosvg.svg",
  //   TOMI: "/assets/tomi-icon-drop.svg",
  //   USDC: "/assets/usdc.svg",
  //   WBTC: "/assets/wbtc.svg",
  //   LINK: "/assets/link.svg", // ✅ added
  //   UNI: "/assets/uni.svg",
  //   PEPE: "/assets/pepe.svg", // ✅ added
  // };

  const tokenConfig = {
    ETH: {
      image: "/assets/eth-icon.svg",
      address: Environment.eth,
    },
    WETH: {
      image: "https://s2.coinmarketcap.com/static/img/coins/64x64/2396.png",
      address: Environment.weth,
    },
    USDT: {
      image: "/assets/usdt.svg",
      address: Environment.busd,
    },
    USDC: {
      image: "/assets/usdc.svg",
      address: Environment.usdc,
    },
    WBTC: {
      image: "/assets/wbtc.svg",
      address: Environment.wbtc,
    },
    PEPE: {
      image: "/assets/pepe.svg",
      address: Environment.pepe,
    },
    DOP: {
      image: "/assets/dop.svg",
      address: Environment.dop,
    },
    UNI: {
      image: "/assets/uni.svg",
      address: Environment.unisape,
    },
    LINK: {
      image: "/assets/link.svg",
      address: Environment.link,
    },
    TOMI: {
      image: "/assets/tomi-icon-drop.svg",
      address: Environment.tomi,
    },
    GEMS: {
      image: "/assets/newgemslogosvg.svg",
      address: Environment.gems,
    },
  };

  const TOKEN_REGISTRY = {
    ETH: {
      hasAllowance: false,
      getBalance: async ({ account, web3 }) => {
        const bal = await web3.eth.getBalance(account);
        return bal / 10 ** 18;
      },
      getPrice: async ({ ethPrice }) => ethPrice(),
    },
    WETH: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountWeth }) =>
        balacefAccountWeth(account),
      getAllowance: async ({ allowanceWeth }) => allowanceWeth(),
      getPrice: async ({ ethPrice }) => ethPrice(),
    },
    USDT: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccount }) =>
        balacefAccount(account),
      getAllowance: async ({ allowanceTpl }) => allowanceTpl(),
      getPrice: async () => null, // USDT = 1 or already handled
    },

    USDC: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountUsdc }) =>
        balacefAccountUsdc(account),
      getAllowance: async ({ allowanceUsdc }) => allowanceUsdc(),
      getPrice: async () => null, // USDC = 1 or already handled
    },

    GEMS: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountGems }) =>
        balacefAccountGems(account),
      getAllowance: async ({ allowanceGems }) => allowanceGems(),
      getPrice: async ({ getGemsPrice }) => getGemsPrice(),
    },

    UNI: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountUni }) =>
        balacefAccountUni(account),
      getAllowance: async ({ allowanceUniswape }) => allowanceUniswape(),
      getPrice: async ({ uniPriceHandler }) => uniPriceHandler(),
    },

    LINK: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountLink }) =>
        balacefAccountLink(account),
      getAllowance: async ({ allowanceLink }) => allowanceLink(),
      getPrice: async ({ linkPrice }) => linkPrice(),
    },

    DOP: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountDop }) =>
        balacefAccountDop(account),
      getAllowance: async ({ allowanceDop }) => allowanceDop(),
      getPrice: async ({ dopPriceHandler }) => dopPriceHandler(),
    },

    PEPE: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountPepe }) =>
        balacefAccountPepe(account),
      getAllowance: async ({ allowancePepe }) => allowancePepe(),
      getPrice: async ({ getPepePrice }) => getPepePrice(),
    },

    TOMI: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountTomi }) =>
        balacefAccountTomi(account),
      getAllowance: async ({ allowanceTomi }) => allowanceTomi(),
      getPrice: async ({ getTomiPrice }) => getTomiPrice(),
    },

    WBTC: {
      hasAllowance: true,
      getBalance: async ({ account, balacefAccountWbtc }) =>
        balacefAccountWbtc(account),
      getAllowance: async ({ allowanceWbtc }) => allowanceWbtc(),
      getPrice: async ({ wbtcPrice }) => wbtcPrice(),
    },
  };

  // console.log(
  //   "maintagggg",
  //   chainId,
  //   parseInt(CHAIN),
  //   account,
  //   selectedToken,
  //   email,
  //   tokenCache,
  // );

  return (
    <>
      {loaderr1 && <Loader />}
      {loaderr && <Loader text={"Sign the transaction in your wallet"} />}
      <Navbar setShow={setShow} />
      <section className="main-banner">
        <img
          src="/assets/leftshade.png"
          alt="leftshade"
          className="leftshade"
        />
        <img
          src="/assets/rightshade.png"
          alt="rightshade"
          className="rightshade"
        />
        <div className="container">
          <div className="banner-content">
            <div className="timermain">
              <div className="innertimer">
                <div className="timerleft">
                  <div className="mainiconimg">
                    <img
                      src={Presale?.image}
                      alt="iconimginner"
                      className="iconimginner"
                    />
                  </div>
                  <div className="mainicontexts">
                    <h6 className="timerhead">{Presale?.name}</h6>
                    <>
                      {currentTime <
                      new Date(parseInt(currentRount?.startTime)) ? (
                        <p className="timerpara">
                          Round {currentRoundd} Starts in:
                        </p>
                      ) : (
                        <>
                          {currentTime >
                            new Date(parseInt(currentRount?.startTime)) &&
                          currentTime <
                            new Date(parseInt(currentRount?.endTime)) ? (
                            <p className="timerpara">
                              Round {currentRoundd} Ends in:
                            </p>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </>
                  </div>
                </div>
                <>
                  {timeshow ? (
                    <p className="timerended">Sale ended!</p>
                  ) : (
                    currentRount !== null &&
                    currentRount !== undefined && (
                      <>
                        <RoundTimer
                          currentRount={currentRount}
                          currentTime={currentTime}
                          setTimeshow={setTimeshow}
                          startTime11={startTime11}
                          history={history}
                          timeshow={timeshow}
                        />
                      </>
                    )
                  )}
                </>
              </div>
              <div className="detailmain">
                <p className="detailpara">
                  Want to learn more about the project?{" "}
                  <a
                    href={`https://stg-automated.gems.vip/${Presale?.detailPage?.toLowerCase()}`}
                    target="_blank"
                    className="greenlink"
                  >
                    Project Details Page
                  </a>
                </p>
              </div>
            </div>

            <div className="twice-content">
              <div className="upper-content">
                <div className="left">
                  <img
                    src={Presale?.image}
                    alt="img"
                    className="img-fluid tokennnimmgg"
                  />
                  <div className="text">
                    <h6>{Presale?.name}</h6>
                    <p>${Presale?.symbol}</p>
                  </div>
                </div>
                <div className="right">
                  <>
                    <>
                      {priceCheck ||
                      (stakedAmount >= 5555 && stakingData?.length > 0) ||
                      moment().isBefore(stakeEndTime1) ? (
                        <>
                          {console.log("special offer chal rha hai", {
                            priceCheck,
                            stakedAmount,
                            stakingData,
                            stakeendtime: moment().isBefore(stakeEndTime1),
                          })}
                          {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                          moment().isBefore(stakeEndTime1) ? (
                            <div className="right-text-content">
                              <div className="inner-left">
                                <h5>Special offer</h5>
                                <p className="special-para">
                                  You save {currentRoundd == 1 ? "20" : "7"}%
                                  {priceCheck ? `+ ${parseInt(percent)}%` : ""}
                                </p>
                              </div>
                              <div className="inner-right">
                                <h6>
                                  {" "}
                                  <h6>
                                    $
                                    {discountedPriceee
                                      ? parseFloat(discountedPriceee)?.toFixed(
                                          8,
                                        )
                                      : "0.000"}{" "}
                                    USD
                                  </h6>
                                </h6>
                                <p>${parseFloat(price).toFixed(8)}</p>
                              </div>
                            </div>
                          ) : !(
                              stakedAmount >= 5555 && stakingData?.length > 0
                            ) || !moment().isBefore(stakeEndTime1) ? (
                            <h6>
                              ${price ? parseFloat(price)?.toFixed(8) : "0.000"}{" "}
                              USD
                            </h6>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <h6>
                          ${price ? parseFloat(price)?.toFixed(8) : "0.000"} USD
                        </h6>
                      )}
                    </>
                  </>
                </div>
              </div>
            </div>
            <div className="discount-offer-removed"></div>
            <div className="custom-tabs">
              <Tabs
                defaultActiveKey={tab}
                id="uncontrolled-tab-example"
                onSelect={tabHandler}
              >
                <Tab eventKey="home" title="Buy Token">
                  <div className="bottom-content">
                    <div className="twice-contentt">
                      <h6 className="main-head m-0">Buy ${Presale?.symbol}</h6>
                      <h6 style={{ fontFamily: "hsemibold" }}>
                        Your Balance:{" "}
                        {tokenCache[selectedToken]?.balance?.toFixed(4) ||
                          "0.000"}{" "}
                        {selectedToken}
                      </h6>
                    </div>

                    <div className="parent-box">
                      <img
                        src="\assets\swap-arrow.svg"
                        alt="img"
                        className="img-fluid swap-arrow"
                      />
                      <div className="inner-box">
                        {" "}
                        <div className="left">
                          <div class="dropdown">
                            <button
                              class="dropdown-toggle"
                              type="button"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <div className="flexset">
                                <img
                                  src={tagImge}
                                  alt="img"
                                  className="img-fluid suxvsvsyucsusc"
                                />
                                <div className="text">
                                  <h6>{selectedToken}</h6>
                                </div>
                              </div>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="8"
                                height="5"
                                viewBox="0 0 8 5"
                                fill="none"
                              >
                                <path
                                  d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                                  fill="#02171D"
                                />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              {allowedTokens?.map((token) => (
                                <li key={token.tokenSymbol}>
                                  <a
                                    className="dropdown-item gscrxcsx"
                                    onClick={() =>
                                      changeTag1(token.tokenSymbol)
                                    }
                                  >
                                    <img
                                      src={
                                        // token.imageUrl ||
                                        tokenConfig[token.tokenSymbol]?.image ||
                                        token?.imageUrl ||
                                        "/assets/default.svg"
                                      } // fallback if not found
                                      alt={token.tokenSymbol}
                                      className="img-fluid"
                                    />{" "}
                                    {token.tokenSymbol}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="right">
                          <h6>
                            $
                            {inputFeild1 && inputFeild
                              ? amountInUsdt?.toLocaleString(undefined, {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2,
                                })
                              : "0.00"}
                          </h6>
                          <input
                            onChange={inputField1Handler}
                            value={inputFeild}
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            placeholder="0.00"
                          />
                          {/* <p>0.00</p> */}
                        </div>
                      </div>
                      <div className="inner-box">
                        <div className="leftiii">
                          <img
                            src={Presale?.image}
                            alt="img"
                            className="img-fluid"
                            style={{
                              width: "35px",
                              height: "35px",
                              borderRadius: "120px",
                            }}
                          />
                          <div className="text">
                            <h6>{Presale?.name}</h6>
                            <p className="textpara">${Presale?.symbol}</p>
                          </div>
                        </div>
                        <div className="right">
                          <h6></h6>
                          <input
                            value={inputFeild1}
                            disabled
                            onWheel={(e) => e.target.blur()}
                            type="number"
                            placeholder="0.00"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="bottom-text">
                      <div className="inner-text-bold">
                        <h6 style={{ textAlign: "start" }}>You Receive:</h6>
                        <h6 style={{ fontFamily: "f37" }}>
                          {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                          moment().isBefore(stakeEndTime1) ? (
                            <>
                              {inputFeild1 && inputFeild
                                ? ethValueCalcualte?.toPrecision(6)
                                : "0.00"}
                            </>
                          ) : (
                            <>
                              {inputFeild1 && inputFeild
                                ? parseFloat(inputFeild1)?.toFixed(3)
                                : "0.00"}
                            </>
                          )}{" "}
                          ${Presale?.symbol}
                        </h6>
                      </div>
                      <div
                        className="inner-text-bold mt-3 w-100"
                        style={{ flexDirection: "column" }}
                      >
                        {checkBoxx && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="w-100 mb-3"
                          >
                            <h6
                              style={{ color: "#329879", textAlign: "start" }}
                            >
                              Gems Protect
                            </h6>
                            <h6>
                              <>
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {(
                                      inputFeild * insurancePer
                                    )?.toLocaleString(undefined, {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 5,
                                    })}
                                  </>
                                ) : (
                                  "0.00"
                                )}
                              </>{" "}
                              {selectedToken}
                              <span
                                style={{
                                  fontSize: "18px",
                                  color: "#77868B",
                                  marginLeft: "5px",
                                }}
                              >
                                ($
                                {inputFeild1 && inputFeild
                                  ? (
                                      amountInUsdt * insurancePer
                                    )?.toLocaleString(undefined, {
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 5,
                                    })
                                  : 0.0}
                                )
                              </span>
                            </h6>
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                          className="w-100"
                        >
                          <h6 style={{ color: "#329879" }}>You Pay:</h6>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                              flexDirection: "column",
                            }}
                          >
                            <h6>
                              <span
                                style={{
                                  fontFamily: "f37",
                                  color: "#329879",
                                }}
                              >
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {checkBoxx
                                      ? parseFloat(
                                          parseFloat(inputFeild) +
                                            inputFeild * insurancePer,
                                        )?.toFixed(4)
                                      : parseFloat(inputFeild)?.toFixed(4)}
                                  </>
                                ) : (
                                  "0.00"
                                )}
                              </span>{" "}
                              <span
                                style={{
                                  fontFamily: "f37",
                                  color: "#329879",
                                }}
                              >
                                {" "}
                                {selectedToken}
                              </span>{" "}
                              <span
                                style={{
                                  fontFamily: "hregular",
                                  color: "#77868B",
                                }}
                              >
                                ($
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {checkBoxx
                                      ? (
                                          amountInUsdt +
                                          amountInUsdt * insurancePer
                                        )?.toLocaleString(undefined, {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 5,
                                        })
                                      : amountInUsdt?.toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 5,
                                          },
                                        )}
                                  </>
                                ) : (
                                  0.0
                                )}
                                )
                              </span>
                            </h6>
                            <p className="networkmain">
                              Network:
                              <span> Ethereum Mainnet</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="custom-checkboxes">
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkDisclaimer}
                            onChange={handleDisclaimerCheckbox}
                          ></input>
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          I have read and understood the disclaimer and hereby
                          agree to its{" "}
                          <a
                            onClick={handleShowTermsServices}
                            style={{ cursor: "pointer" }}
                          >
                            terms and conditions
                          </a>
                          .<span>*</span>
                        </p>
                      </div>
                      {attemptedDisclaimer && !readDisclaimer && (
                        <p className="error-text">
                          To continue, please open and review the Terms &
                          Conditions.
                        </p>
                      )}
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkCitizenship}
                            onChange={(e) =>
                              setCheckCitizenship(e.target.checked)
                            }
                          />
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          I hereby confirm that I am not a citizen of the United
                          States of America or Israel<span>*</span>
                        </p>
                      </div>
                      <div className="checkboxmainnnnnn">
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={checkMerketing}
                            onChange={(e) =>
                              setCheckMerketing(e.target.checked)
                            }
                          />
                          <span class="checkmark"></span>
                        </label>
                        <p className="checkboxpara">
                          I acknowledge that I may receive marketing
                          communications.
                        </p>
                      </div>
                    </div>
                    <p className="approvepara">
                      You will need to approve the transaction in your wallet.
                    </p>
                    {account ? (
                      <>
                        {!timeshow &&
                        currentTime >
                          new Date(parseInt(currentRount?.startTime)) &&
                        currentTime <
                          new Date(parseInt(currentRount?.endTime)) ? (
                          <>
                            {inputFeild == "" ||
                            inputFeild == null ||
                            !canBuy ||
                            inputFeild <= 0 ? (
                              <button className=" btn-buy">
                                Buy ${Presale?.symbol}
                              </button>
                            ) : (
                              <button
                                className="newClasss"
                                onClick={handlerPop}
                              >
                                Buy ${Presale?.symbol}{" "}
                              </button>
                            )}
                          </>
                        ) : (
                          <button className="btn-buy">
                            Buy ${Presale?.symbol}
                          </button>
                        )}
                      </>
                    ) : (
                      <button className="btn-buy" onClick={() => setShow(true)}>
                        Buy ${Presale?.symbol}
                      </button>
                    )}
                  </div>
                </Tab>

                {Presale?.nftDetails.length > 0 && (
                  <Tab eventKey="profile" title="Buy NFTs">
                    <DopNft
                      projectId={projectId}
                      currentRount={currentRount}
                      email={email}
                      timeshow={timeshow}
                      setShow={setShow}
                      price={price}
                      code={code}
                      setLoarder={setLoarder}
                      saleCurrentStaus={saleCurrentStaus}
                      currentRoundd={currentRoundd}
                      discoundedPriceee={discoundedPriceee}
                      tab={tab}
                      stakeIndex={stakeIndex}
                      stakedAmount={stakedAmount}
                      discountedPriceee={discountedPriceee}
                      round={round}
                      insurancePer={insurancePer}
                      checkBoxx={checkBoxx}
                      allowedTokens={allowedTokens}
                      selectedToken={selectedToken}
                      tagImge={tagImge}
                      tokenConfig={tokenConfig}
                      tokenCache={tokenCache}
                      changeTag1={changeTag1}
                      fetchTokenData={fetchTokenData}
                      getGasFeeInUSD={getGasFeeInUSD}
                      buyingNetworkFee={buyingNetworkFee}
                      setbuyingNetworkFee={setbuyingNetworkFee}
                      stakingData={
                        (stakedAmount >= 5555 && stakingData?.length > 0) ||
                        moment().isBefore(stakeEndTime1)
                          ? true
                          : false
                      }
                    />
                  </Tab>
                )}
              </Tabs>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <Modal
        className="connectwallet-modal connectwallet-newmodal"
        show={!isVerificationDone}
        // onHide={handleCloseVerification}
        centered
        enforceFocus={false}
      >
        <Modal.Header>
          <div className="multi-steps">
            <div className="common-step">
              {account ? (
                <>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <rect width="30" height="30" rx="15" fill="#329879" />
                    <path
                      d="M21.1448 13.0837L21.1448 7.93555L13.3011 15.7597L8.625 12.4608L8.625 17.2336L13.3011 20.7571L21.1448 13.0837Z"
                      fill="#ECF5F9"
                    />
                  </svg>
                </>
              ) : (
                <span className={account ? "" : "active"}>1</span>
              )}
              <h6>Connect Wallet</h6>
            </div>
            <span className="middle-line"></span>
            <div className={`common-step `}>
              <span className={account ? "active" : ""}>2</span>
              <h6>Confirm Email</h6>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!account ? (
            <div className="connect-wallet-parent">
              <div className="upper-heading">
                <h6>Connect Your Wallet</h6>
                <p>
                  Choose your preferred wallet to continue with the purchase
                </p>
              </div>
              <div className="wallets-parent">
                <button onClick={connectMetaMask1} className="d-noneformobile">
                  <img
                    src="\assets\metamask.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  Metamask
                </button>
                <button onClick={trustWallet}>
                  <img
                    src="\assets\walletconnect.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  WalletConnect
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="ifwalletconnected">
                <div className="left-text">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1737_20899)">
                      <circle
                        cx="6.99963"
                        cy="6.99963"
                        r="6.99963"
                        fill="#329879"
                      />
                      <path
                        d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1737_20899">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <p>Wallet Connected:</p>
                </div>
                <h6>
                  {/* <img src="\assets\metamask-mini-icon.svg" alt="img" className="img-fluid" /> */}
                  {account.slice(0, 6)}...{account.slice(-4)}
                </h6>
              </div>
              {isEmailVerified && (
                <div className="continue-with-verifiedemail">
                  <div className="upper-heading">
                    <h6>Continue with verified email?</h6>
                    <p>
                      Your wallet is associated with a verified email. You'll
                      receive a confirmation there once your purchase is
                      complete
                    </p>
                  </div>
                  <div className="verifiedemail-box">
                    <div className="left-content">
                      <p>Verified Email</p>
                      <h6>{email}</h6>
                    </div>
                    <h6 className="verifiedlabel">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clip-path="url(#clip0_1737_20947)">
                          <circle
                            cx="6.99963"
                            cy="6.99963"
                            r="6.99963"
                            fill="#329879"
                          />
                          <path
                            d="M5.71603 10.5958L2.63379 7.51373L3.66111 6.48641L5.71603 8.54119L10.3391 3.91797L11.3664 4.94529L5.71603 10.5958Z"
                            fill="#E2E9EC"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1737_20947">
                            <rect width="14" height="14" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Email Verified
                    </h6>
                  </div>
                </div>
              )}
              {!isEmailVerified && (
                <>
                  <div className="ifanother-email">
                    <div className="upper-heading">
                      <h6>Enter Your Email</h6>
                      <p>
                        Provide your email address to receive purchase
                        confirmations.
                      </p>
                    </div>
                    <div className="option-field">
                      <label>Email Address</label>
                      <input
                        type="email"
                        value={email}
                        placeholder="your@email.com"
                        onChange={handleInputMail}
                        className={!isValidMail ? "error" : ""}
                      />
                      {!isValidMail && (
                        <p className="error-text">Invalid Email</p>
                      )}
                      {isMailVerificationChecked && (
                        <a
                          href="#"
                          className={`btn-send ${
                            !isValidMail || isResendDisabled ? "disabled" : ""
                          }`}
                          onClick={handleSendCode}
                          style={{
                            pointerEvents: isResendDisabled ? "none" : "auto",
                            opacity: !isValidMail || isResendDisabled ? 0.5 : 1,
                          }}
                        >
                          {isResendDisabled
                            ? `Resend in ${resendTimer}s`
                            : codeSentOnce
                              ? "Resend "
                              : "Send Code"}
                        </a>
                      )}
                    </div>
                    {otpRequired && codeSentOnce && (
                      <div className="option-field">
                        <label>Verification Code</label>
                        <input
                          type="text"
                          value={otp}
                          onChange={(e) => {
                            setOtp(e.target.value);
                            setIsCodeValid(true);
                          }}
                          className={isCodeValid ? "" : "error"}
                          placeholder="Enter 6-digit code here"
                        />
                        {!isCodeValid && (
                          <p className="error-text">
                            Invalid email verification code
                          </p>
                        )}
                      </div>
                    )}
                    {isMailVerificationChecked &&
                      otpRequired &&
                      !codeSentOnce && (
                        <div className="email-not-veirified-error">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_1790_1877)">
                              <circle
                                cx="8.99953"
                                cy="8.99953"
                                r="8.99953"
                                fill="#FC4F52"
                              />
                              <path
                                d="M11.3328 13.091L8.89564 9.88506L6.63258 13.091H4.90918L8.00783 8.69953L5.11808 4.90918H6.8763L9.06972 7.79786L11.1413 4.90918H12.8473L10.7235 7.81456H9.08713L13.091 13.091H11.3328Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1790_1877">
                                <rect width="18" height="18" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p>
                            This email is not verified. Please verify it to
                            continue.
                          </p>
                        </div>
                      )}
                  </div>
                  <div className="bottom-btns">
                    {codeSentOnce ? (
                      <button
                        className="btn-common"
                        disabled={!isCodeValid || otp.length <= 0}
                        style={{
                          opacity:
                            !isCodeValid || otp.length <= 0 ? "0.5" : "1",
                        }}
                        onClick={handlVerifyCode}
                      >
                        Verify
                      </button>
                    ) : (
                      <button
                        className="btn-common"
                        disabled={otpRequired}
                        style={{ opacity: otpRequired ? "0.5" : "1" }}
                        onClick={handlCheckEmailVerification}
                      >
                        Continue
                      </button>
                    )}
                  </div>
                </>
              )}
              {isEmailVerified && (
                <div className="bottom-btns">
                  <button
                    className="btn-common"
                    onClick={handleContinueWithVerifiedMail}
                  >
                    Continue with this Email
                  </button>
                  <button
                    className="btn-another"
                    onClick={handleContinueWithAnotherEmail}
                  >
                    Use a different email
                  </button>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show1}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>${Presale?.symbol} Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <h4>${Presale?.symbol} Purchase Completed !</h4>
            <p>Here’s a summary of your transaction</p>
            <div className="token-purchased-area">
              <div className="single-value">
                <h5>
                  Tokens Received
                  <div className="tooltipmain">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M6.99984 12.8332C10.2215 12.8332 12.8332 10.2215 12.8332 6.99984C12.8332 3.77818 10.2215 1.1665 6.99984 1.1665C3.77818 1.1665 1.1665 3.77818 1.1665 6.99984C1.1665 10.2215 3.77818 12.8332 6.99984 12.8332Z"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 4.6665V6.99984"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 9.3335H7.00583"
                        stroke="#77868B"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <div className="innertooltip">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                        className="arrowsvg"
                      >
                        <path
                          d="M5.36598 0.989823C6.87409 -0.329768 9.12591 -0.329767 10.634 0.989824L16 5.68506H0L5.36598 0.989823Z"
                          fill="#C0CBCF"
                        />
                      </svg>
                      Added to your wallet balance shortly after confirmation
                    </div>
                  </div>
                </h5>
                <h6>
                  {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                  moment().isBefore(stakeEndTime1) ? (
                    <>
                      {inputFeild1 && inputFeild
                        ? ethValueCalcualte?.toPrecision(6)
                        : "0.00"}
                    </>
                  ) : (
                    <>
                      {inputFeild1 && inputFeild
                        ? parseFloat(inputFeild1)?.toFixed(3)
                        : "0.00"}
                    </>
                  )}{" "}
                  ${Presale?.symbol}
                </h6>
              </div>
            </div>
            <div className="token-purchased-area tokenpurchasedlast">
              {/* {checkBoxx && ( */}
              <div className="single-value">
                <h5>Token Purchase Amount</h5>
                <h6>
                  {inputFeild1 && inputFeild ? parseFloat(inputFeild) : "0.00"}{" "}
                  {selectedToken}{" "}
                  <span>
                    ($
                    {inputFeild1 && inputFeild
                      ? amountInUsdt?.toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 5,
                        })
                      : 0.0}
                    )
                  </span>
                </h6>
              </div>
              {/* )} */}
              {checkBoxx && (
                <div className="single-value">
                  <h5>Gems Protect</h5>
                  <h6>
                    <>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {(inputFeild * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            },
                          )}
                        </>
                      ) : (
                        "0.00"
                      )}
                    </>{" "}
                    {selectedToken}
                    <span>
                      ($
                      {inputFeild1 && inputFeild
                        ? (amountInUsdt * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            },
                          )
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              <div
                className={
                  checkBoxx ? "single-value newborderr" : "single-value"
                }
                style={{
                  borderBottom: !checkBoxx ? "none" : "1px solid #C0CBCF",
                }}
              >
                <h5>Total Spent (incl. network fees) </h5>
                <h6 style={{ color: "#329879" }}>
                  {inputFeild1 && inputFeild ? (
                    <>
                      {checkBoxx
                        ? parseFloat(
                            parseFloat(inputFeild) + inputFeild * insurancePer,
                          )
                        : parseFloat(inputFeild)}
                    </>
                  ) : (
                    "0.00"
                  )}{" "}
                  {selectedToken}{" "}
                  <span style={{ color: "#77868B" }}>
                    ($
                    {inputFeild1 && inputFeild ? (
                      <>
                        {checkBoxx
                          ? (
                              amountInUsdt +
                              amountInUsdt * insurancePer +
                              buyingNetworkFee
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })
                          : (amountInUsdt + buyingNetworkFee)?.toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 5,
                              },
                            )}
                      </>
                    ) : (
                      0.0
                    )}
                    )
                  </span>
                </h6>
              </div>
            </div>

            <button
              className="btn-common"
              onClick={() => {
                handleClose();
              }}
              style={{ marginTop: "20px" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Terms
        showtermsservices={showtermsservices}
        handleCloseTermsServices={handleCloseTermsServices}
      />
    </>
  );
};

export default Banner;
